// extracted by mini-css-extract-plugin
export default {"wrapper":"iconWithBadge_wrapper__fR-wm","badgeWrapper":"iconWithBadge_badgeWrapper__axG2V"};